import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

type Props = {
    showModal: boolean
}
const ContainerModalAllPage: React.FC<Props> = ({ showModal, children }) => {
    useEffect(() => {
        let bodyStyle = document.body
        showModal
            ? (bodyStyle.style.overflowY = 'hidden')
            : bodyStyle.removeAttribute('style')
    }, [showModal])

    if (!showModal) return null

    return createPortal(
        <div id="root-portal-all-page">
            <div className="contentModal-all-page">{children}</div>
        </div>,
        document.body,
    )
}

export default ContainerModalAllPage
